import React from 'react';
import {
  CommandLineIcon,
  HomeIcon,
  ShoppingCartIcon,
  UserGroupIcon,
  TagIcon,
  UsersIcon,
  ChartBarIcon,
  MegaphoneIcon,
  BanknotesIcon,
  PhotoIcon,
  ChatBubbleLeftRightIcon,
  GlobeAltIcon,
  DevicePhoneMobileIcon,
  SparklesIcon,
  QuestionMarkCircleIcon,
  Cog6ToothIcon,
  UserPlusIcon,
  RectangleGroupIcon,
  TicketIcon,
  ArrowsRightLeftIcon,
  FlagIcon,
  StarIcon,
  DocumentTextIcon,
  Bars3BottomLeftIcon,
  CalendarDaysIcon,
  CalculatorIcon,
  CheckCircleIcon,
  CodeBracketSquareIcon,
  HandRaisedIcon,
  PaperClipIcon,
  PencilSquareIcon,
  QueueListIcon,
  LanguageIcon,
  CurrencyDollarIcon,
  MapPinIcon,
  SpeakerWaveIcon,
  Squares2X2Icon,
  CodeBracketIcon,
  VideoCameraIcon,
  SwatchIcon,
  PuzzlePieceIcon,
  TruckIcon,
  CreditCardIcon,
  ReceiptPercentIcon,
  KeyIcon,
  SquaresPlusIcon,
  ListBulletIcon,
  ClipboardDocumentListIcon,
  BuildingStorefrontIcon,
  CubeIcon,
  CpuChipIcon,
  AdjustmentsHorizontalIcon,
  BookOpenIcon,
  WrenchScrewdriverIcon,
  ShieldExclamationIcon,
  CurrencyEuroIcon,
  GlobeAmericasIcon,
  CreditCardIcon as CreditCardOutlineIcon,
} from '@heroicons/react/24/outline';

const AgentIcon = ({size, color}) => (
  <svg width={size} height={size} viewBox="0 0 620 620" fill="none" xmlns="http://www.w3.org/2000/svg" style={{flexShrink: 0}}>
    <circle cx="310" cy="310" r="220" stroke={color} strokeOpacity="0.3" strokeWidth="1.6"/>
    <circle cx="310" cy="310" r="170" stroke={color} strokeOpacity="0.45" strokeWidth="1.6"/>
    <circle cx="310" cy="310" r="120" stroke={color} strokeOpacity="0.65" strokeWidth="1.6"/>
    <rect x="258" y="270" width="104" height="80" rx="20" fill={color} fillOpacity="0.9"/>
    <path d="M310 250V270M298 250H322" stroke={color} strokeWidth="5" strokeLinecap="round"/>
    <circle cx="286" cy="309" r="8" fill="rgba(0,0,0,0.5)"/>
    <circle cx="334" cy="309" r="8" fill="rgba(0,0,0,0.5)"/>
    <path d="M286 330C300 340 320 340 334 330" stroke="rgba(0,0,0,0.5)" strokeWidth="5" strokeLinecap="round"/>
    <circle cx="250" cy="310" r="10" fill={color}/>
    <circle cx="370" cy="310" r="10" fill={color}/>
  </svg>
);

const IntelligenceIcon = ({size, color}) => (
  <svg width={size} height={size} viewBox="0 0 620 620" fill="none" xmlns="http://www.w3.org/2000/svg" style={{flexShrink: 0}}>
    <circle cx="310" cy="310" r="220" stroke={color} strokeOpacity="0.3" strokeWidth="1.6"/>
    <circle cx="310" cy="310" r="170" stroke={color} strokeOpacity="0.45" strokeWidth="1.6"/>
    <circle cx="310" cy="310" r="120" stroke={color} strokeOpacity="0.65" strokeWidth="1.6"/>
    <path d="M310 238L323 297L382 310L323 323L310 382L297 323L238 310L297 297L310 238Z" fill={color} fillOpacity="0.9"/>
    <circle cx="310" cy="310" r="18" fill="rgba(0,0,0,0.4)" stroke={color} strokeWidth="1.6"/>
    <path d="M310 299V321M299 310H321" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const ICON_MAP = {
  // Main nav
  'get started':        HomeIcon,
  'mcp':                CpuChipIcon,
  'commerce':           BuildingStorefrontIcon,
  'commerce reports':   ChartBarIcon,
  'orders':             ShoppingCartIcon,
  'accounts':           UserGroupIcon,
  'listings':           TagIcon,
  'users':              UsersIcon,
  'report':             ChartBarIcon,
  'promotions':         MegaphoneIcon,
  'finance':            BanknotesIcon,
  'media':              PhotoIcon,
  'communication':      ChatBubbleLeftRightIcon,
  'customer chat':      ChatBubbleLeftRightIcon,
  'web':                GlobeAltIcon,
  'app':                DevicePhoneMobileIcon,
  'marketing':          MegaphoneIcon,
  'tradly attribution': ChartBarIcon,
  'social connect':     ChatBubbleLeftRightIcon,
  'bundles':            CubeIcon,
  'help':               QuestionMarkCircleIcon,
  'settings':           Cog6ToothIcon,
  'invite team':        UserPlusIcon,

  // Attribute field types
  'single select':      HandRaisedIcon,
  'multi select':       Squares2X2Icon,
  'open (single value)': PencilSquareIcon,
  'open (multi value)': QueueListIcon,
  'attachment':         PaperClipIcon,
  'text area':           Bars3BottomLeftIcon,
  'date time':           CalendarDaysIcon,
  'number':              CalculatorIcon,
  'boolean':             CheckCircleIcon,
  'color':               SwatchIcon,
  'json':                CodeBracketSquareIcon,
  'location':            MapPinIcon,
  'audio':               SpeakerWaveIcon,
  'video':               VideoCameraIcon,

  // Sub-menus
  'collections':        RectangleGroupIcon,
  'coupons':            TicketIcon,
  'transactions':       ArrowsRightLeftIcon,
  'reported listings':  ShieldExclamationIcon,
  'reviews & ratings':  StarIcon,
  'account categories': ListBulletIcon,
  'account attributes': AdjustmentsHorizontalIcon,
  'account configuration': Cog6ToothIcon,
  'categories':         ListBulletIcon,
  'custom attributes':  AdjustmentsHorizontalIcon,
  'variant types':      CubeIcon,
  'additional features':SquaresPlusIcon,
  'inventory':          ClipboardDocumentListIcon,
  'user attributes':    AdjustmentsHorizontalIcon,
  'promotion / ads':    MegaphoneIcon,
  'website editor':     SwatchIcon,
  'change templates':   SwatchIcon,
  'pages':              DocumentTextIcon,
  'blog':               BookOpenIcon,
  'customise texts':    LanguageIcon,
  'add integrations':   PuzzlePieceIcon,
  'domain':             GlobeAmericasIcon,
  'buy app templates':  DevicePhoneMobileIcon,
  'customisation':      WrenchScrewdriverIcon,
  'integrations':       PuzzlePieceIcon,
  'checkout & cart attributes': ShoppingCartIcon,
  'service / shipping': TruckIcon,
  'payments':           CreditCardIcon,
  'commissions':        ReceiptPercentIcon,
  'subscription':       KeyIcon,
  'taxes':              ReceiptPercentIcon,
  'special fees':       CurrencyEuroIcon,
  'languages':          LanguageIcon,
  'currency':           CurrencyDollarIcon,
  'countries':          MapPinIcon,
  'api':                CodeBracketIcon,
  'documentation':      DocumentTextIcon,
  'community':          UserGroupIcon,
  'api reference':      CodeBracketIcon,
  'channels':           BuildingStorefrontIcon,

  'subscription':       CreditCardOutlineIcon,
  'people':             UserGroupIcon,
  'workforce':          CalendarDaysIcon,
  'payroll':            BanknotesIcon,

  // Special app icons (custom SVG)
  'agents':             AgentIcon,
  'intelligence':       IntelligenceIcon,
  'vibe coding':        CommandLineIcon,
  'coding kits':        CodeBracketSquareIcon,
};

const CUSTOM_SVG = new Set(['agents', 'intelligence']);

const MenuIcon = ({title = '', size = 20, color = 'currentColor', className = ''}) => {
  const key = title.toLowerCase();
  const Icon = ICON_MAP[key] ?? Cog6ToothIcon;
  if (CUSTOM_SVG.has(key)) {
    return <Icon size={size} color={color} />;
  }
  return (
    <Icon
      width={size}
      height={size}
      color={color}
      className={`shrink-0 ${className}`}
      strokeWidth={1.5}
    />
  );
};

export default MenuIcon;
